<nz-card nzTitle="ECOs">
  <ng-container *ngIf="error$ | async as errorMsg; else resultTpl">
    <em-error-result [subTitle]="errorMsg"></em-error-result>
  </ng-container>

  <ng-template #resultTpl>
    <nz-skeleton [nzActive]="true" [nzLoading]="(designLoading$ | async) ?? false">
      <nz-table
        #ecoTable
        [nzData]="(ecos$ | async) ?? []"
        [nzLoading]="ecosLoading$ | async"
        nzSize="small"
        nzFrontPagination="false"
      >
        <thead>
          <tr>
            <th>ECO number</th>
          </tr>
        </thead>
        <tbody class="em-no-table-row-hover">
          <tr *ngFor="let eco of ecoTable.data; trackBy: trackByRef">
            <td>
              <a *ngIf="eco.link" target="_blank" href="{{ eco.link }}">
                {{ eco.id | trimZeroes }}
              </a>
              <ng-template #noLink>
                {{ eco.id | trimZeroes }}
              </ng-template>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </nz-skeleton>
  </ng-template>
</nz-card>
